import styled from 'styled-components';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';

interface WrapperProps {
  isDragging?: boolean;
  isUnassigned?: boolean;
  isEditable?: boolean;
}

export const Wrapper = styled(Box)<WrapperProps>(
  ({ isDragging, isUnassigned, isEditable, theme }) => {
    const defaultStyles = {
      display: 'flex',
      borderRadius: theme.radii.medium,
      background: theme.colors.bg,
      padding: isEditable ? '16px 8px' : 16,
      gap: 6,
    };

    if (isDragging) {
      return {
        ...defaultStyles,
        background: theme.colors.primary[100],
        border: `1px solid ${theme.colors.primary[300]}`,
        boxShadow: theme.shadows['500'],
      };
    }

    if (isUnassigned) {
      return {
        ...defaultStyles,
        border: `1px solid ${theme.colors.neutral[300]}`,
        boxShadow: theme.shadows['300'],
        alignItems: 'center',
      };
    }

    return {
      ...defaultStyles,

      '&:nth-child(odd)': {
        background: theme.colors.neutral['100'],
      },
    };
  },
);
